import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  Button,
  Typography,
  DialogActions,
  IconButton,
  CircularProgress,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
  dialog: {
    '& .MuiPaper-root': {
      borderRadius: 5,
      padding: 24,
      boxSizing: 'border-box',
    },
  },
  dialogActions: {
    '&.MuiDialogActions-root': {
      justifyContent: 'space-between',
    },
  },
  button: {
    width: 200,
    height: 40,
    '&:last-child': {
      marginLeft: 30,
    },
  },
  closeButton: {
    position: 'absolute',
    right: 0,
    top: 0,
  },
  title: {
    margin: '0 auto',
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'row',
    alignContent: 'center',
    alignItems: 'center',
  },
}));

const DeleteDialog = ({ ...props }) => {
  const { open, name, onClick, isLoading, onClickDelete } = props;
  const classes = useStyles();
  const [dialogOpen, setDialogOpen] = useState(open);

  const handleClose = () => {
    onClick();
  };

  const handleDelete = () => {
    onClickDelete();
  };

  useEffect(() => {
    setDialogOpen(open);
  }, [open]);

  return (
    <Dialog
      open={dialogOpen}
      onClose={handleClose}
      className={classes.dialog}
      maxWidth={'md'}
    >
      <DialogTitle className={classes.title} disableTypography>
        <Typography variant="h4">
          ¿Deseas eliminar la dirección &quot;{name}&quot;?
        </Typography>
        <IconButton className={classes.closeButton} onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogActions className={classes.dialogActions}>
        <Button
          onClick={handleClose}
          variant="outlined"
          color="secondary"
          className={classes.button}
        >
          Cancelar
        </Button>
        <Button
          onClick={handleDelete}
          variant="contained"
          color="primary"
          className={classes.button}
          disabled={isLoading}
        >
          {isLoading ? (
            <CircularProgress size={24} color={'white'} />
          ) : (
            <React.Fragment>Eliminar</React.Fragment>
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DeleteDialog.propTypes = {
  open: PropTypes.bool,
  name: PropTypes.string,
  isLoading: PropTypes.bool,
  onClick: PropTypes.func,
  onClickDelete: PropTypes.func,
};

export default DeleteDialog;
